import React from 'react';
import { BsCloudDownloadFill } from 'react-icons/bs';
import { FiWifiOff } from 'react-icons/fi';
import { FaDatabase } from 'react-icons/fa';

const TableHandler = ({ data, loading, error }) => {
  return (
    <div>
      {loading && 
        <div className="table-message">
          <BsCloudDownloadFill size={60} />
          <p>Fetching request...</p>
        </div>
      }
      {(data?.length === 0 && !error && !loading) &&
        <div className="table-message">
          <FaDatabase size={65} />
          <p>No data found for your search!</p>
        </div>
      }
      {error && 
        <div className="table-message">
          <FiWifiOff size={60} />
          <p>You're offline. Check your connection.</p>
        </div>
      }
    </div>
  )
}

export default TableHandler;
